import React from 'react'
import { cn } from 'src/utils/style'

interface ContentPaneProps {
  children: React.ReactNode
  className?: string
}

/**
 * Main column of a list page: takes the remaining width next to an optional
 * `FilterPane` and is a container-query root, so rows/cards respond to the
 * column width rather than the viewport. No header — the title and page
 * actions live in `PageHeader`, list controls in `ListToolbar`.
 */
export const ContentPane: React.FC<ContentPaneProps> = ({ children, className }) => {
  return <div className={cn('min-w-0 flex-grow space-y-4 @container', className)}>{children}</div>
}
